import {useCallback, useEffect, useRef} from 'react';
import {getAdCreditsFromSessionStorage, updateAdCredits} from 'app/helpers/adStepper';
import CustomDomEvents from 'app/types/events/CustomDomEvents';
import Video from 'app/components/tv/models/video';
import VideoEventDefaultDetail from 'app/types/events/VideoEventDefaultDetail';

const useAdCredits = (video: Video | null) => {
  const initAdCredits = getAdCreditsFromSessionStorage();
  const adCreditsRef = useRef(initAdCredits);
  const lastVideoRef = useRef<string | null>(null);

  const handleUpdateAdCredits = useCallback((event: CustomEvent<VideoEventDefaultDetail>) => {
    if (lastVideoRef.current === event.detail.video.slug) {
      return;
    }
    lastVideoRef.current = event.detail.video.slug;
    updateAdCredits(event.detail.video, event.detail.played, adCreditsRef);
  }, []);

  useEffect(() => {
    window.addEventListener(CustomDomEvents.VideoEnded, handleUpdateAdCredits);
    window.addEventListener(CustomDomEvents.VideoChanged, handleUpdateAdCredits);
    window.addEventListener(CustomDomEvents.PlayerLeft, handleUpdateAdCredits);
    return () => {
      window.removeEventListener(CustomDomEvents.VideoEnded, handleUpdateAdCredits);
      window.removeEventListener(CustomDomEvents.VideoChanged, handleUpdateAdCredits);
      window.removeEventListener(CustomDomEvents.PlayerLeft, handleUpdateAdCredits);
    };
  }, [handleUpdateAdCredits]);

  useEffect(() => {
    return () => {
      lastVideoRef.current = null;
    };
  }, [video]);

  return adCreditsRef;
};

export default useAdCredits;
